import { canv } from "@/canv/global";
import { getNewStartY } from "@/shapeStorage/utils";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeTerminator extends Shape {
    width = 200;
    height = 118;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 7) / 8 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;

        textPart.startY = getNewStartY(textPart, y, height, verticalPadding, null);

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, w: number, h: number) {
        canv.ctx.beginPath();

        let r = h / 2;

        if (w < 2 * r) r = w / 2;

        canv.ctx.moveTo(x + r, y);
        canv.ctx.arcTo(x + w, y, x + w, y + r, r);
        canv.ctx.arcTo(x + w, y + h, x + w - r, y + h, r);
        canv.ctx.arcTo(x, y + h, x, y + h - r, r);
        canv.ctx.arcTo(x, y, x + r, y, r);

        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" stroke="${stroke}" d="M1 12c0-3.59 2.95-6.5 6.6-6.5h8.8c3.65 0 6.6 2.91 6.6 6.5s-2.95 6.5-6.6 6.5H7.6A6.55 6.55 0 0 1 1 12Z"/>
            </svg>
        `;
    }
}
